import { ObjectsDialogBaseComponent } from "./objects-dialog-base/objects-dialog-base.component";
import { Component, inject, Injector } from "@angular/core";
import { ErrorReplyWithArgs } from "../../../models/ErrorModels";



@Component({
  selector: 'app-create-object',
  templateUrl: './objects-dialog-base/objects-dialog-base.component.html',
  styleUrls: ['./objects-dialog-base/objects-dialog-base.component.css'],
  standalone: false
})
export class CreateObjectsComponent extends ObjectsDialogBaseComponent {

  constructor(protected injector: Injector) {
    super(injector);
    this.dialogId = "createObject";
  }

  public submit() {

    if (!this.ModelValidate())
      return;
    this.model.Id = 0;
    this.objectsService.CreateObject(this.model)
      .subscribe(() => {
        this.onCreated.emit();
        this.close();
        super.submit();
      }, (error: ErrorReplyWithArgs) => {
        // this.toastr.error(exportFailedMsg);
        this.toastr.error(this.translate.instant(error.reply, { 0: error.args }));
      });
  }
}
